import { useRef } from "react";
import { Navigate, Outlet } from "react-router-dom";

import { useAuthStore } from "@/stores/auth-store";

/**
 * The decision is snapshotted at mount on purpose. The auth pages establish a
 * session *while mounted* and then navigate on their own via
 * usePostLoginRedirect. Reacting to that later session change would race with
 * (and sometimes override) that page-driven navigation, e.g. sending a
 * brand-new user to "/" instead of "/onboarding".
 */
export function GuestGuard() {
  const { isAuthenticated } = useAuthStore();
  const wasAuthenticatedAtMount = useRef(isAuthenticated);

  if (wasAuthenticatedAtMount.current) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
